import api from './api';

export interface FinanceHealthMetric {
  amount?: number;
  value?: string | number;
  days?: number | string;
  percentage?: number;
  label: string;
  status: string;
  benchmark?: string;
  trend?: string;
}

export interface FinanceHealthAlert {
  type: string;
  title: string;
  message: string;
  icon: string;
}

export interface FinanceHealthData {
  healthScore: number;
  status: string;
  statusColor: string;
  metrics: {
    cashPosition: FinanceHealthMetric;
    quickRatio: FinanceHealthMetric;
    daysOfCash: FinanceHealthMetric;
    burnRate: FinanceHealthMetric;
    revenueGrowth: FinanceHealthMetric;
  };
  trends: {
    revenue: Array<{ period: string; amount: number }>;
    expenses: Array<{ period: string; amount: number }>;
  };
  alerts: FinanceHealthAlert[];
}

const financeHealthService = {
  // Get finance health dashboard
  getFinanceHealth: async (): Promise<FinanceHealthData> => {
    const response = await api.get<{ success: boolean; data: FinanceHealthData }>('/finance-health');
    return response.data.data;
  },
};

export default financeHealthService;
